import { styled } from '@/styled-system/jsx';

export const CarouselContainer = styled('div', {
  base: {
    position: 'relative',
  },
});

export const CarouselHeader = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
});

export const CarouselTitle = styled('div', {
  base: {
    fontSize: 'lg',
    fontWeight: '600',
    margin: 0,
  },
  variants: {
    isHdpFeaturedListings: {
      true: {
        fontSize: 'md',
      },
    },
  },
});

export const SeeAllButtonWrapper = styled('div', {
  base: {
    whiteSpace: 'nowrap',
  },
});

export const CarouselContentWrapper = styled('div', {
  base: {
    position: 'relative',
  },
});

export const CarouselItemsContainer = styled('div', {
  base: {
    overflowX: 'clip',
    overflowY: 'visible',
    paddingBottom: '16px',
    touchAction: 'pan-y',
    width: '100%',
  },
  variants: {
    freeScrollMode: {
      true: {
        overflowX: 'auto',
        overflowY: 'hidden',
        touchAction: 'pan-x pan-y',
        scrollBehavior: 'smooth',
      },
    },
    showScrollbar: {
      false: {
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Edge
        },
      },
    },
  },
  compoundVariants: [
    {
      freeScrollMode: true,
      showScrollbar: false,
      css: {
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Edge
        },
      },
    },
  ],
});

export const CarouselSlider = styled('ul', {
  base: {
    display: 'flex',
    transitionProperty: 'transform',
    transitionDuration: '0.13s',
    transitionTimingFunction: 'ease-out',
    width: '100%',
    gap: '16px',
  },
  variants: {
    freeScrollMode: {
      true: {
        transitionProperty: 'none',
        width: 'max-content',
      },
    },
  },
});

export const CarouselItem = styled('li', {
  base: {
    flexShrink: 0,
    boxSizing: 'border-box',
  },
});

// For skip to beginning and skip to end buttons with keyboard navigation
export const SkipButton = styled('button', {
  base: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 100,
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '24px',
    paddingRight: '24px',
    backgroundColor: 'hpxTeal500',
    color: 'hpxWhite',
    border: 'none',
    borderRadius: '8px',
    fontSize: 'md',
    fontWeight: '600',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    opacity: 0,
    pointerEvents: 'none',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
    _focusVisible: {
      opacity: 1,
      pointerEvents: 'auto',
      backgroundColor: 'hpxTeal600',
      outlineWidth: '3px',
      outlineStyle: 'solid',
      outlineColor: 'hpxTeal700',
      outlineOffset: '2px',
    },
  },
  variants: {
    position: {
      top: {
        top: '48px',
      },
      bottom: {
        bottom: '24px',
      },
    },
  },
});
